(function (global) {
  'use strict';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var decPart = parts[1] ? decimal + parts[1] : '';
    return intPart + decPart;
  }

  function stripHtmlToPlain(text) {
    var s = String(text == null ? '' : text);
    if (s.indexOf('<') === -1) return s;
    if (typeof document !== 'undefined') {
      var div = document.createElement('div');
      div.innerHTML = s;
      var plain = (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
      if (plain) return plain;
    }
    return s.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  function money(cents) {
    if (cents == null) cents = 0;
    var fmt = (global.theme && global.theme.settings && global.theme.settings.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    var value = formatWithDelimiters(cents, 2);
    if (match) {
      switch (match[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(placeholderRegex, value);
    }
    return fmt + (cents / 100).toFixed(2);
  }

  function fetchCartForValidation() {
    var cartUrl = (global.theme && global.theme.routes && global.theme.routes.cart) || '/cart.js';
    return fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      });
  }

  function showNativeDiscountError(form, input, message) {
    if (!form) return;
    var existing = form.querySelector('.discount-rules-validation-error');
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'form-error discount-rules-validation-error';
      if (input && input.parentNode) {
        input.parentNode.insertAdjacentElement('afterend', existing);
      } else {
        form.insertAdjacentElement('afterbegin', existing);
      }
    }
    existing.textContent = message || '';
  }

  function clearNativeDiscountError(form) {
    if (!form) return;
    var existing = form.querySelector('.discount-rules-validation-error');
    if (existing) existing.remove();
  }

  function resubmitForm(form) {
    form.dataset.discountRulesSkip = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function bindNativeDiscountForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (form.dataset.discountRulesSkip === '1') {
        form.dataset.discountRulesSkip = '';
        return;
      }
      if (form.matches('[data-custom-cart-discount-form]')) return;

      var input = form.querySelector('[name="discount"]');
      if (!input) return;
      var code = String(input.value || '').trim();
      if (!code) return;

      var verification = global.DiscountVerification;
      if (!verification || typeof verification.verify !== 'function') return;

      e.preventDefault();
      e.stopPropagation();

      fetchCartForValidation()
        .then(function (cart) {
          var customer = typeof verification.resolveCustomerPayload === 'function'
            ? verification.resolveCustomerPayload({})
            : null;
          var options = typeof verification.buildValidationOptions === 'function'
            ? verification.buildValidationOptions(cart, { customer: customer })
            : {
              cartItems: cart.items || [],
              subtotalCents: cart.total_price || 0,
              customer: customer
            };
          return verification.verify(code, options);
        })
        .then(function (result) {
          if (result && result.ok === false) {
            showNativeDiscountError(form, input, result.message);
            return;
          }
          clearNativeDiscountError(form);
          resubmitForm(form);
        })
        .catch(function () {
          resubmitForm(form);
        });
    }, true);
  }

  global.DiscountRulesValidation = {
    fetchCartForValidation: fetchCartForValidation,
    formatMoney: money,
    formatMoneyPlain: function (cents) {
      return stripHtmlToPlain(money(cents));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindNativeDiscountForms);
  } else {
    bindNativeDiscountForms();
  }
})(window);
